import IconHomepageChapter1 from '@listening/assets/astro/icons/icon-homepage-chapter-1.svg?react';
import IconHomepageChapter2 from '@listening/assets/astro/icons/icon-homepage-chapter-2.svg?react';
import IconHomepageChapter3 from '@listening/assets/astro/icons/icon-homepage-chapter-3.svg?react';
import SaveTimeChapters from '@listening/assets/astro/images/new-design-25/homepage/save-time-chapters.png';
import { CtaButton } from '@/components/astro/cta-button/cta-button.tsx';
import { useFreePlan } from '@/hooks/use-free-plan-availability';
import * as m from '@/paraglide/messages';

export function SaveTime() {
  const { isInFreePlanCountry } = useFreePlan();
  return (
    <section
      aria-labelledby='save-time-title'
      className='container mx-auto px-4 py-16 md:py-24'
    >
      <div className='grid items-end gap-12 lg:grid-cols-2'>
        <div
          aria-label='Paper sections interface demonstration'
          className='order-1'
          role='img'
        >
          <img
            alt='Chapters image'
            aria-hidden='true'
            className='mx-auto w-full max-w-[500px] lg:max-w-none'
            src={SaveTimeChapters}
            // quality={100}
            // format="png"
          />
        </div>

        <div className='order-1 mb-8 space-y-8 text-center lg:order-2 lg:mb-12 lg:text-left'>
          <IconHomepageChapter1
            aria-hidden='true'
            className='mx-auto size-6 md:size-10 lg:mx-0'
          />
          <h2
            className='text-2xl font-bold text-black lg:text-4xl xl:text-6xl'
            id='save-time-title'
          >
            {m.homepage_save_time_title()}
          </h2>

          <ul
            aria-label='Key features'
            className='space-y-6 text-neutral-665 md:space-y-8'
          >
            <li className='flex items-start justify-center gap-4 lg:justify-start'>
              <IconHomepageChapter1 aria-hidden='true' className='size-6' />
              <p>{m.homepage_save_time_feature_1()}</p>
            </li>
            <li className='flex items-start justify-center gap-4 lg:justify-start'>
              <IconHomepageChapter2 className='size-6' />
              <p>{m.homepage_save_time_feature_2()}</p>
            </li>
            <li className='flex items-start justify-center gap-4 lg:justify-start'>
              <IconHomepageChapter3 className='size-6' />
              <p>{m.homepage_save_time_feature_3()}</p>
            </li>
          </ul>
          <div className='relative'>
            <CtaButton
              className='bg-royal-50 md:w-auto'
              label={
                isInFreePlanCountry
                  ? m.common_try_for_free()
                  : m.common_try_now()
              }
            />
          </div>
        </div>
      </div>
    </section>
  );
}
